/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2023-09-14 11:36:10
 * @LastEditTime: 2023-11-01 14:53:53
 * @LastEditors: WangYuhan
 */
import Layout from '@/layout';

const accountsRouter = {
  path: `/accounts`,
  component: Layout,
  redirect: `/accounts/accounts`,
  alwaysShow: true, // will always show the root menu
  name: 'Accounts',
  meta: {
    id: 6,
    title: '账目管理',
    icon: 'yzs_zhangmu',
    roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE'],
  },
  children: [
    {
      path: 'accountsManagement',
      component: () => import('@/views/accounts/accountsManagement'),
      name: 'accounts',
      meta: {
        id: 61,
        title: '账目明细',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE'],
      },
    },
  ],
};
export default accountsRouter;
